module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('span', {
    staticClass: "calibre1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("A PERMUTED PRESS BOOK")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("Published at Smashwords")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("ISBN (eBook): 978-1-68261-375-7")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("Martial Law")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("The Journal  Book 6")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_c('span', {
    attrs: {
      "xml:lang": "ar-SA"
    }
  }, [_vm._v("© 2017 ")]), _vm._v("by Deborah D. Moore")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("All Rights Reserved")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("Cover art by Christian Bentulan ")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("This book is a work of fiction. People, places, events, and situations are the product of the author’s imagination. Any resemblance to actual persons, living or dead, or historical events, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means without the written permission of the author and publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_c('span', [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "Image15359.JPG",
      "src": "Images/Image15359_fmt.jpeg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v(" Permuted Press, LLC")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("109 International Drive, Suite 300")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("Franklin, TN 37067")]), _vm._v(" "), _c('p', {
    staticClass: "Text2"
  }, [_vm._v("Published in the United States of America"), _c('span', {
    staticClass: "char-style-override1"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d53374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/theJournal-1.vue
// module id = 63
// module chunks = 0